import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, ScheduledAgentMessageResponse } from "@/types";

// Polls slower than the message list: a queued send's fire time is fixed at
// enqueue and only changes when the chain dies.
const REFETCH_INTERVAL_MS = 60_000;

export const scheduledAgentMessagesQueryKey = (candidacyId: string | null) =>
  ["scheduled-agent-messages", candidacyId] as const;

export function useGetScheduledAgentMessages({
  candidacyId,
}: {
  candidacyId: string | null;
}) {
  return useQuery({
    queryKey: scheduledAgentMessagesQueryKey(candidacyId),
    refetchInterval: REFETCH_INTERVAL_MS,
    queryFn: async () => {
      if (!candidacyId) return [];

      const path = `staffer-agent-conversations/${candidacyId}/scheduled-messages`;
      const res = await guacHttpClient.get<
        ScheduledAgentMessageResponse[],
        HttpResponse<ScheduledAgentMessageResponse[]>
      >(path);
      return res.data;
    },
  });
}
